import Component from "./../../component";
import {isElementScrolledToEnd} from "../../helpers/scrolling";
import {getTrottledFunction} from "../../helpers/throttle";

export const CartDrawerBodyConfig = {
    signature: 'cartDrawerBody',
    baseHtmlClass: 'go-cart-drawer__body',
    selector: '.go-cart-drawer__body',

    initedHtmlClassModifier: 'inited',
};

export class CartDrawerBody extends Component {

    constructor(id_or_element, goCart) {
        super({
            element: id_or_element,
            config: CartDrawerBodyConfig
        });

        this.goCart = goCart;

        this.moreIndicatorElement = createMoreIndicatorElement();
        this.element.appendChild(this.moreIndicatorElement);

        let throttledRenderer = getTrottledFunction(this.render.bind(this), 100);
        this.element.addEventListener('scroll', throttledRenderer);
        this.resizeObserver = new ResizeObserver(throttledRenderer);
        this.resizeObserver.observe(this.element);

        this.inited = true;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, CartDrawerBodyConfig.initedHtmlClassModifier);
        this.swapHtmlClassStates(isElementScrolledToEnd(this.element), 'scrolled', 'unscrolled');
    }

}

function createMoreIndicatorElement() {
    let element = document.createElement('div');
    element.classList.add(`${CartDrawerBodyConfig.baseHtmlClass}__more_indicator`);
    element.innerHTML = `<span>More</span>`;
    return element;
}
